import { detect } from 'detect-browser'

export const isSafari = (): boolean => {
  const { os, name } = detect()
  return (os === 'iOS' && name === 'ios') || (os === 'Mac OS' && name === 'safari')
}
